import { options } from './Options'

export const SystemRoleOptions: options[] = [
  { label: 'Adviser', value: 'adviser' },
  { label: 'Supervisor', value: 'supervisor' },
  { label: 'Director', value: 'director' },
  { label: 'Ops-Staff', value: 'ops-staff' },
  { label: 'Product Admin', value: 'product-admin' },
  { label: 'BSC Reviewer', value: 'bsc-reviewer' }
]
